export { B as Battery, G as Cart, C as Content, D as Device, E as EventHub, H as History, A as Http, M as Media, N as Navigation, z as Network, P as Polyglot, y as Screen, S as Settings, W as Wifi, X as XpBgImg, x as XpedeoPlugin, K as beforeEach, d as debounce, e as entryMixin, L as getXpedeoPrefixUrlPageId, h as handleExternalUrl, f as handleUrl, l as lipSync, I as localPageDataMixin, F as nfc, J as nonLangPageRedirect, i as pageMixin, t as throttle } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
//# sourceMappingURL=index.js.map
